import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { faMagnifyingGlass, faCaretUp, faCaretDown, faChevronDown, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {ContentService} from "../../../data-access/content.service";
import * as _ from "lodash"
import {APIResponse} from "../../../../shared/data-access/api-response.model";
import {MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
interface ProblemTemplate {
  tag_list: Tag[]
  problemtemplate_id: number,
  name: string,
  learningobjective_id: string,
  is_static: boolean,
  answer_type: string,
  source: string
  source_id: string,
  active: boolean,
  createdate: Date,
  last_updated: Date
  isActionOpened: boolean
  menuItems: MenuItem[]
}
interface Tag {
  tag_id: number,
  name: string
}
enum AnswerTypes {
  MULTIPLECHOICE,
  OPENANSWER,
  MULTIFIELD,
  PASSAGE,
  FORMULA,
  CANVAS,
  TEXTAREA,
  MULTIPLE3D,
  ORDERING,
  GROUPING
}
interface OnInit {
  ngOnInit(): void
}

@Component({
    selector: 'problemTemplateList',
    templateUrl: './problemTemplateList.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class ProblemTemplateList implements OnInit {
  constructor(public router: Router, private route: ActivatedRoute, private contentService: ContentService) {
  }
  learningObjectiveID: number = -1
  ccl_id: number = -1
  subject_id: number = -1
  problemTemplates: ProblemTemplate[] = []
  isActionOpened = false
  faMagnifyingGlass = faMagnifyingGlass
  faCaretUp = faCaretUp
  faCaretDown = faCaretDown
  faChevronDown = faChevronDown
  faArrowLeft = faArrowLeft
  faArrowRight = faArrowRight
  isDescending: boolean = false
  isTypeDescending: boolean = false
  isDateDescending: boolean = false
  searchText: string = ""
  isLoading: boolean = false
  pageNumber: number = 0
  maxPage: number = 0
  totalCount: number = 0
  errorText: string = ""
  errorDialog: boolean = false
  limitIsOpened: boolean = false
  pageScrollOver = 0
  pageNumberList: number[] = []
  limit: number = 10
  limitMenu: MenuItem[] = [{
    title: '10',
    action: this.getPage,
    item_id: 10
  },{
    title: '25',
    action: this.getPage,
    item_id: 25
  },{
    title: '50',
    action: this.getPage,
    item_id: 50
  }]
  searchIconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; margin-left: 0.5rem; flex-shrink: 1;`
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Subject List',
    route: 'dashboard/ContentViewer/SubjectList'
  }, {
    text: 'CCL Tree',
    route: 'dashboard/ContentViewer/SubjectList/CCLTree'
  }, {
    text: 'Learning Objectives',
    route: 'dashboard/ContentViewer/SubjectList/CCLTree/LearningObjectives'
  }]

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['learningobjective_id'] != null)
        this.learningObjectiveID = params['learningobjective_id']
      if(params['ccl_id'] != null)
        this.ccl_id = params['ccl_id']
      if(params['subject_id'] != null)
        this.subject_id = params['subject_id']

      if(this.subject_id != null && this.subject_id !== -1)
        this.breadcrumbNavs[1].queryParams = {queryParams: {subject_id: this.subject_id}}

      if(this.ccl_id != null && this.ccl_id !== -1) {
        this.breadcrumbNavs[2].queryParams = {queryParams: {subject_id: this.subject_id, ccl_id: this.ccl_id}}
      } else {
        this.breadcrumbNavs[2].queryParams = {queryParams: {subject_id: this.subject_id}}
      }

      this.isLoading = true
      this.contentService.listProblemTemplates(this.learningObjectiveID, 0, this.limit, "", "", this.isDescending).subscribe((response) => {
        this.handleResponse(response)
        for(let i = 0; i <= this.maxPage; i++)
          this.pageNumberList.push(i+1)
      })

    })
  }

  debounceSearch = _.debounce(() => {
    this.isLoading = true
    this.contentService.listProblemTemplates(this.learningObjectiveID, 0, this.limit, this.searchText).subscribe((response) => {
      this.handleResponse(response)
    })
  }, 750)

  toggleNameDescending() {
    this.isDescending = !this.isDescending
    this.isTypeDescending = false
    if(!this.isDescending)
      this.problemTemplates.sort((a,b) => this.sort(a.name,b.name))
    else
      this.problemTemplates.sort((a,b) => this.reverse(a.name,b.name))
  }

  sort(a: string, b: string): number {
    if(a < b)
      return -1
    if(a > b)
      return 1
    return 0
  }

  reverse(a: string, b: string): number {
    if(a > b)
      return -1
    if(a < b)
      return 1
    return 0
  }

  decrementPage() {
    if(this.pageNumber !== 0) {
      this.pageNumber -= 1
      this.adjustScrollOver()
      this.getPage()
    }
  }
  incrementPage() {
    if(this.pageNumber + 1 !== this.maxPage + 1) {
      this.pageNumber += 1;
      this.adjustScrollOver()
      this.getPage()
    }
  }

  getPage() {
    this.isLoading = true
    this.contentService.listProblemTemplates(this.learningObjectiveID, this.pageNumber, this.limit, this.searchText, "", this.isDescending).subscribe((response) => {
      this.handleResponse(response)
      this.pageNumberList = []
      for(let i = 0; i <= this.maxPage; i++)
        this.pageNumberList.push(i+1)
    })
  }

  handleResponse(response: APIResponse) {
    if(response.success) {
      this.problemTemplates = response.result.items
      for(let problem of this.problemTemplates){
        problem.menuItems = [
          {
            title: 'Preview Template',
            route: 'dashboard/ContentViewer/SubjectList/CCLTree/LearningObjectives/ProblemTemplates/Preview',
            queryParams: {queryParams: {problemtemplate_id: problem.problemtemplate_id, learningobjective_id: this.learningObjectiveID, ccl_id: this.ccl_id, subject_id: this.subject_id}}
          }]
      }
      this.maxPage = Math.floor(response.result.totalcount / this.limit)
      this.totalCount = response.result.totalcount
    } else {
      this.errorDialog = true
      this.errorText = response.msg
    }
    this.isLoading = false
  }

  toggleTypeDescending() {
    this.isTypeDescending = !this.isTypeDescending
    this.isDescending = false
    if(!this.isTypeDescending)
      this.problemTemplates.sort((a,b) => this.sort(a.answer_type,b.answer_type))
    else
      this.problemTemplates.sort((a,b) => this.reverse(a.answer_type,b.answer_type))
  }

  toggleDateDescending() {
    this.isDateDescending = !this.isDateDescending
    this.isDescending = false
    this.isTypeDescending = false
    if(!this.isDateDescending)
      this.problemTemplates.sort((a,b) => {return new Date(a.last_updated).getTime() - new Date(b.last_updated).getTime()})
    else
      this.problemTemplates.sort((a,b) => {return new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime()})
  }

  selectPage(page: number) {
    if(this.pageNumber !== page - 1) {
      this.pageNumber = page - 1
      this.adjustScrollOver()
      this.getPage()
    }
  }

  adjustScrollOver() {
    if(this.pageNumber + 1 === (this.pageScrollOver + 1) * 3 )
      this.pageScrollOver++
    else if(this.pageNumber + 1 === (this.pageScrollOver * 3) - 1 && this.pageScrollOver !== 0)
      this.pageScrollOver--
  }
}
